import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { GridOptions } from "ag-grid-community";
import moment from "moment";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { BehaviorSubject, Subscription } from "rxjs";
import { takeWhile } from "rxjs/operators";
import { AlertService } from "src/app/services/alert/alert.service";
import { CarrierService } from "src/app/services/carrier/carrier.service";
import { DelinquencyReportService } from "src/app/services/delinquency-report/delinquency-report.service";
import { LoadingService } from "src/app/services/loading/loading.service";
import { User } from "src/app/services/user/user";
import { UserService } from "src/app/services/user/user.service";
import AppConstants from "src/app/shared/common-components/AppConstants";
import { ConfirmationModalComponent } from "src/app/shared/common-components/confirmation-modal/confirmation-modal.component";
import { CommonHelpers } from "src/app/shared/common-helpers";

@Component({
    selector: 'app-tsp-hhg-shpmnt-rpt-status',
    templateUrl: './tsp-hhg-shpmnt-rpt-status.component.html',
    styleUrls: ['./tsp-hhg-shpmnt-rpt-status.component.css'],
    standalone: false
})
export class TspHhgShpmntRptStatusComponent implements OnInit {
  reportingYrList: any;
  tmssloader: any;
  iffDelinqReport: FormGroup;
  resultsSubscription = new Subscription();
  rowData: any;
  delinqEmailStatus: any;
  emailStatusMessage: string = null;
  columnsDefs: any;
  gridApi;
  gridColumnApi;
  hhDelinqReport4thQuarter;
  modalRef: BsModalRef;
  showDelinqMessage: Boolean;
  isRfsp: Boolean;
  rfspCarrierList: any[];
  rfspScacList: any[];
  rfspCarrierId: number;
  selectedCarrierId: number;
  carrierEntity: any;
  private observer$ = new BehaviorSubject(true);
  currentUser: User;
  selectedTsp: any;
  qtrList: any = [{
    "value": -1,
    "name": "All Quarters"
  },{
    "value": 1,
    "name": "Quarter 1 (January - March)"
  },
    {
      "value": 2,
      "name": "Quarter 2 (April - June)"
    },
    {
      "value": 3,
      "name": "Quarter 3 (July - September)"
    },
    {
      "value": 4,
      "name": "Quarter 4 (October - December)"
    }];

  printQtrList:any =[];

  toolTipValueGetter = function (params: any) {
    return {value: params.value};
  };
  curdate: string;
  curMonth: number;
  curYear: number;
  curQtr: number;

  constructor(private router: Router,
              private delinquentService: DelinquencyReportService,
              private loader: LoadingService,
              private alertService: AlertService,
              private modalService: BsModalService,
              private fb: FormBuilder,
              private userService: UserService,
              private carrierService: CarrierService
  ){

  }

  ngOnInit() {
    this.isRfsp = false;
    this.selectedCarrierId = 0;
    this.userService.getCurrentUserObservable()
      .pipe(takeWhile(() => this.observer$.value)).subscribe(currentUser => {
      this.currentUser = currentUser;
      console.log("carrier id in tsp hh shipment report status: ");
      console.log(this.currentUser.carrierId);
    }, (error) => {
      console.log("ERROR: error when retrieving permission for user");
    });

    this.tmssloader = this.loader;
    this.tmssloader.show();
    this.emailStatusMessage = '';
    this.loadTspsForRfsp();
    this.populateDelinqYear();
    this.populateDelinqReportFormGroup();
    this.tmssloader.hide();
    this.generateListofQtr();
  }
  onShipmentReportClicked(){
    this.router.navigate(['/hhgComprehensiveReport']);
  }
  getLastDayOfQuarterMonth(date: any) {
    let retVal = moment(date, "MM-DD-YYYY").endOf('quarter').toDate();
    return retVal;
  }
  loadTspsForRfsp(){
    console.log("sy load tsp rfsp");
    this.carrierService.getCarrierByCarrierId(this.currentUser.carrierId).subscribe(carrier => {
      this.carrierEntity = carrier;
      this.isRfsp = this.carrierEntity.carrierType === 'RFSP';
      this.isRfsp ? this.rfspCarrierId = this.carrierEntity.carrierId : this.rfspCarrierId = 0;
      console.log("rsfp carrier id:" + this.rfspCarrierId);
      if(this.isRfsp){
        this.carrierService.getAllRfspsCarriersIff(this.carrierEntity.carrierId).subscribe(
         result => { 
           this.rfspCarrierList = result;
           this.rfspCarrierList.sort((a,b) => a.scac > b.scac ? 1 : -1);            
           console.log(this.rfspCarrierList);
           this.rfspScacList = this.rfspCarrierList.map(s => s.scac);
           console.log(this.rfspScacList);
         }, error => {
          this.alertService.error('Error while getting rfsp tsp list');
          }
        );
      }
    });
   
  }

  tspChange(event:any){
    this.selectedTsp = this.iffDelinqReport.get('tspListSelect').value;
    console.log(this.selectedTsp);
    let tsp = this.rfspCarrierList.filter(r => r.scac === this.selectedTsp);
    this.selectedCarrierId = tsp[0].carrierId;
    console.log(this.selectedCarrierId);
  }  
  generateListofQtr() {
    this.printQtrList = [];
    const curYear = new Date().getFullYear();
    const inputYear = Number(this.iffDelinqReport.get('reportingYrSelect').value);
    if (curYear === inputYear) {
      const currQtr = moment().quarter();
      var currDate = new Date();

      if (currQtr === 1) { this.qtrList = null; }
      if (currQtr === 2) {
        const lastQtrDate = this.getLastDayOfQuarterMonth('01-01-' + curYear);
        if (moment(currDate).diff(moment(lastQtrDate), 'days') > 60) {
          this.printQtrList = this.qtrList.filter(qtr => qtr.value === 1);
        }
      }
      if (currQtr === 3) {
        const lastQtrDate = this.getLastDayOfQuarterMonth('06-01-' + curYear);
        if (moment(currDate).diff(moment(lastQtrDate), 'days') > 60) {
          this.printQtrList = this.qtrList.filter(qtr => qtr.value < 3);
        } else
          this.printQtrList = this.qtrList.filter(qtr => qtr.value === 1);
      }

      if (currQtr === 4) {
        const lastQtrDate = this.getLastDayOfQuarterMonth('09-01-' + curYear);
        if (moment(currDate).diff(moment(lastQtrDate), 'days') > 60) {
          this.printQtrList = this.qtrList.filter(qtr => qtr.value < 4);
        } else
          this.printQtrList = this.qtrList.filter(qtr => qtr.value < 3);
      }
    } else {
      if (curYear === inputYear - 1) {
        const currQtr = moment().quarter();
        if (currQtr === 1) {
          const currDate = new Date();
          const lastQtrDate = this.getLastDayOfQuarterMonth('09-01-' + inputYear);
          if (moment(lastQtrDate).diff(moment(currDate), 'days') < 60) {
            this.printQtrList = this.qtrList.filter(qtr => qtr.value < 4);
          }else
            this.printQtrList = this.qtrList;
        }
      }else
        this.printQtrList = this.qtrList;
    }
    console.log(this.printQtrList);
  }

  populateDelinqReportFormGroup() {
    this.iffDelinqReport = this.fb.group({
      tspListSelect: new FormControl(''),
      reportingYrSelect: new FormControl('', Validators.required),
      reportingQtrSelect: new FormControl('', Validators.required)
    });
  }

  sendDelinquentEmails() {
    if (this.checkQuarterYear()) {
      this.modalRef = this.modalService.show(ConfirmationModalComponent);
      this.modalRef.content.question = 'Are you Sure, Do you want to send delinquent emails for ' + this.iffDelinqReport.value.reportingYrSelect + ' Quarter ' + this.iffDelinqReport.value.reportingQtrSelect ;
      this.modalRef.content.title = 'Sending IFF Delinquent Emails';
      this.modalRef.content.confirmText = 'Yes';
      this.modalRef.content.cancelText = 'No';
      this.modalRef.content.emitData.subscribe(result => {
        if (result.obj === true) {
          this.delinquentService.sendDelinquentEmails(Number(this.iffDelinqReport.value.reportingYrSelect), Number(this.iffDelinqReport.value.reportingQtrSelect),'HHG').subscribe(res => {
            this.alertService.success('Delinquent emails have been sent to the TSPs.');
          }, error => {
            this.tmssloader.hide();
            this.alertService.error('There was an error sending your email');
          });
        }
      });
    }

  }
  getDelinqEmailStatus() {
    this.generateListofQtr();
    if (this.iffDelinqReport.value.reportingYrSelect !== "" && this.iffDelinqReport.value.reportingQtrSelect !== "") {
      this.showDelinqMessage = (this.iffDelinqReport.value.reportingQtrSelect === "-1") ? false : true;
      this.resultsSubscription = this.delinquentService.getDelinqEmailStatus(Number(this.iffDelinqReport.value.reportingYrSelect), Number(this.iffDelinqReport.value.reportingQtrSelect),'HHG').subscribe(res => {
        if (res !== null && res !== undefined ) {
          this.delinqEmailStatus = res;
          this.emailStatusMessage = 'Delinquency email for '+ this.iffDelinqReport.value.reportingYrSelect + ' Quarter ' + this.iffDelinqReport.value.reportingQtrSelect + ' was last sent on ' + this.delinqEmailStatus.delinqStausMsg;
        }else{
          this.delinqEmailStatus =null;
          this.emailStatusMessage = 'Email was never sent for '+ this.iffDelinqReport.value.reportingYrSelect + ' Quarter ' + this.iffDelinqReport.value.reportingQtrSelect ;
        }
      });
    }
  }
  populateDelinqYear() {
    this.tmssloader.show();
    this.delinquentService.getIffDelinqYearViewOnly().subscribe(yearList => {
      this.reportingYrList = yearList.reverse();
      this.tmssloader.hide();
    }, error => {
      this.tmssloader.hide();
      this.alertService.error('There was an error retrieving year list');
    });
  }
  getIFFDelinqReport() {
    this.loader.show();
    let carrierId = 0;
    carrierId =  (this.selectedCarrierId > 0) ? Number(this.selectedCarrierId) : Number(this.currentUser.carrierId);
    this.resultsSubscription = this.delinquentService.getTspDelinqReport(carrierId,Number(this.iffDelinqReport.value.reportingYrSelect), Number(this.iffDelinqReport.value.reportingQtrSelect),'HHG').subscribe(res => {
      if (res !== null && res !== undefined && res.length > 0) {
        this.rowData = CommonHelpers.sortAtoZ(res);
        if(Number(this.iffDelinqReport.value.reportingQtrSelect) === -1){
          this.gridApi.setColumnDefs(this.getColumnDef(-1));
        }else{
          this.gridApi.setColumnDefs(this.getColumnDef(0));
        }
        const rptQtr = Number(this.iffDelinqReport.value.reportingQtrSelect);
        const carrierRoles = AppConstants.DelindReportStatus();
        switch(rptQtr) {
          case 1:
            this.rowData= res.filter(
              (v:any) =>
                (carrierRoles.includes(v.last1stQuarterGIStatus) || carrierRoles.includes(v.last1stQuarterIMStatus)
                  || carrierRoles.includes(v.last1stQuarterGDStatus) || carrierRoles.includes(v.last1stQuarterDMStatus))
            );
            break;
          case 2:
            this.rowData= res.filter(
              (v:any) =>
                (carrierRoles.includes(v.last2ndQuarterGIStatus) || carrierRoles.includes(v.last2ndQuarterIMStatus)
                  || carrierRoles.includes(v.last2ndQuarterGDStatus) || carrierRoles.includes(v.last2ndQuarterDMStatus))
            );
            break;
          case 3:
            this.rowData= res.filter(
              (v:any) =>
                (carrierRoles.includes(v.last3rdQuarterGIStatus) || carrierRoles.includes(v.last3rdQuarterIMStatus)
                  || carrierRoles.includes(v.last3rdQuarterGDStatus) || carrierRoles.includes(v.last3rdQuarterDMStatus))
            );
            break;
          case 4:
            this.rowData= res.filter(
              (v:any) =>
                (carrierRoles.includes(v.last4thQuarterGIStatus) || carrierRoles.includes(v.last4thQuarterIMStatus)
                  || carrierRoles.includes(v.last4thQuarterGDStatus) || carrierRoles.includes(v.last4thQuarterDMStatus))
            );
            break;
          case -1:
            this.rowData = res.filter(
              (v: any) => (
                (carrierRoles.includes(v.last1stQuarterGIStatus) || carrierRoles.includes(v.last1stQuarterIMStatus)
                  || carrierRoles.includes(v.last1stQuarterGDStatus) || carrierRoles.includes(v.last1stQuarterDMStatus)) ||
                (carrierRoles.includes(v.last2ndQuarterGIStatus) || carrierRoles.includes(v.last2ndQuarterIMStatus)
                  || carrierRoles.includes(v.last2ndQuarterGDStatus) || carrierRoles.includes(v.last2ndQuarterDMStatus)) ||
                (carrierRoles.includes(v.last3rdQuarterGIStatus) || carrierRoles.includes(v.last3rdQuarterIMStatus)
                  || carrierRoles.includes(v.last3rdQuarterGDStatus) || carrierRoles.includes(v.last3rdQuarterDMStatus)) ||
                (carrierRoles.includes(v.last4thQuarterGIStatus) || carrierRoles.includes(v.last4thQuarterIMStatus)
                  || carrierRoles.includes(v.last4thQuarterGDStatus) || carrierRoles.includes(v.last4thQuarterDMStatus))
              )
            );
          default:
            break;
        }
        this.gridApi.setDatasource(this.rowData);
        this.loader.hide();
      } else {
        this.rowData = null;
        this.loader.hide();
      }
    });
  }
  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.setDatasource(this.rowData);
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }
  gridOptions: GridOptions = {
    rowSelection: 'multiple',
    defaultColDef: {
      sortable: true,
      resizable: true,
      filter: 'agNumberColumnFilter',
      filterParams: {
        suppressAndOrCondition: false
      }
    },
    pagination: true,
    paginationPageSize: 10,
    cacheBlockSize: 25,
    headerHeight: 50,
    domLayout: 'autoHeight',
    suppressDragLeaveHidesColumns: true,

    overlayLoadingTemplate:
      '<span class="ag-overlay-loading-center">Select the Reporting Year/Quarter to load report.</span>',
    overlayNoRowsTemplate:
      '<span>No results found. Please adjust your filters.</span>'
  };
  getColumnDef(quarter:number) {
    if(quarter === 0){
      return [
        {
          colId: 'scac',
          headerName: 'SCAC',
          field: 'scac',
          filter: 'agTextColumnFilter',
          sortable: true
        },
        {
          colId: 'last4thQuarter',
          headerValueGetter: () => {
            const tempq = Number(this.iffDelinqReport.value.reportingQtrSelect);
            return (tempq === 4) ? this.iffDelinqReport.value.reportingYrSelect + ' 4th Quarter' :
              (tempq === 3) ? this.iffDelinqReport.value.reportingYrSelect + ' 3rd Quarter' :
                (tempq === 2) ? this.iffDelinqReport.value.reportingYrSelect +' 2nd Quarter' : this.iffDelinqReport.value.reportingYrSelect + ' 1st Quarter';

          },
          marryChildren: true,
          children: [
            {
              headerName: 'GI',
              valueGetter: (params) => {
                const tempq = Number(this.iffDelinqReport.value.reportingQtrSelect);
                return (tempq === 4) ? params.data.last4thQuarterGIStatus :
                  (tempq === 3) ? params.data.last3rdQuarterGIStatus :
                    (tempq === 2) ? params.data.last2ndQuarterGIStatus : params.data.last1stQuarterGIStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            },
            {
              headerName: 'IM',
              valueGetter: (params) => {
                const tempq = Number(this.iffDelinqReport.value.reportingQtrSelect);
                return (tempq === 4) ? params.data.last4thQuarterIMStatus :
                  (tempq === 3) ? params.data.last3rdQuarterIMStatus :
                    (tempq === 2) ? params.data.last2ndQuarterIMStatus : params.data.last1stQuarterIMStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            },
            {
              headerName: 'GD',
              valueGetter: (params) => {
                const tempq = Number(this.iffDelinqReport.value.reportingQtrSelect);
                return (tempq === 4) ? params.data.last4thQuarterGDStatus :
                  (tempq === 3) ? params.data.last3rdQuarterGDStatus :
                    (tempq === 2) ? params.data.last2ndQuarterGDStatus : params.data.last1stQuarterGDStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            },
            {
              headerName: 'DM',
              valueGetter: (params) => {
                const tempq = Number(this.iffDelinqReport.value.reportingQtrSelect);
                return (tempq === 4) ? params.data.last4thQuarterDMStatus :
                  (tempq === 3) ? params.data.last3rdQuarterDMStatus :
                    (tempq === 2) ? params.data.last2ndQuarterDMStatus : params.data.last1stQuarterDMStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            }
          ]
        },
        {
          colId: 'POC Contact',
          marryChildren: true,
          headerName: 'POC Contact',
          children: [
            {
              headerName: 'Full Name',
              valueGetter: (params) => {
                return params.data.pocFirstName + ' ' + params.data.pocLastName;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            },
            {
              headerName: 'Email',
              valueGetter: (params) => {
                return (params.data.email.length > 0) ? params.data.email.toLowerCase() : 'Not Available';
              },
              filter: 'agTextColumnFilter',
              sortable: true
            }
          ]
        }
      ];
    }else{

      return [
        {
          colId: 'scac',
          headerName: 'SCAC',
          field: 'scac',
          filter: 'agTextColumnFilter',
          sortable: true
        },
        {
          colId: '1stQuarter',
          headerValueGetter:  () => {
            return this.iffDelinqReport.value.reportingYrSelect + ' 1st Quarter';

          },
          marryChildren: true,
          children: [
            {
              headerName: 'GI',
              valueGetter: (params) => {
                return params.data.last1stQuarterGIStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            },
            {
              headerName: 'IM',
              valueGetter: (params) => {
                return params.data.last1stQuarterIMStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            },
            {
              headerName: 'GD',
              valueGetter: (params) => {
                return params.data.last1stQuarterGDStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            },
            {
              headerName: 'DM',
              valueGetter: (params) => {
                return params.data.last1stQuarterDMStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            }
          ]
        },
        {
          colId: '2nd Quarter',
          headerValueGetter:  () => {
            return this.iffDelinqReport.value.reportingYrSelect + ' 2nd Quarter';

          },
          marryChildren: true,
          children: [
            {
              headerName: 'GI',
              valueGetter: (params) => {
                return params.data.last2ndQuarterGIStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            },
            {
              headerName: 'IM',
              valueGetter: (params) => {
                return params.data.last2ndQuarterIMStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            },
            {
              headerName: 'GD',
              valueGetter: (params) => {
                return params.data.last2ndQuarterGDStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            },
            {
              headerName: 'DM',
              valueGetter: (params) => {
                return params.data.last2ndQuarterDMStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            }
          ]
        },
        {
          colId: '3rd Quarter',
          headerValueGetter:  () => {
            return this.iffDelinqReport.value.reportingYrSelect + ' 3rd Quarter';

          },
          marryChildren: true,
          children: [
            {
              headerName: 'GI',
              valueGetter: (params) => {
                return params.data.last3rdQuarterGIStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            },
            {
              headerName: 'IM',
              valueGetter: (params) => {
                return params.data.last3rdQuarterIMStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            },
            {
              headerName: 'GD',
              valueGetter: (params) => {
                return params.data.last3rdQuarterGDStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            },
            {
              headerName: 'DM',
              valueGetter: (params) => {
                return params.data.last3rdQuarterDMStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            }
          ]
        },
        {
          colId: '4th Quarter',
          headerValueGetter: () => {
            return  this.iffDelinqReport.value.reportingYrSelect + ' 4th Quarter';

          },
          marryChildren: true,
          children: [
            {
              headerName: 'GI',
              valueGetter: (params) => {
                return params.data.last4thQuarterGIStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            },
            {
              headerName: 'IM',
              valueGetter: (params) => {
                return params.data.last4thQuarterIMStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            },
            {
              headerName: 'GD',
              valueGetter: (params) => {
                return params.data.last4thQuarterGDStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            },
            {
              headerName: 'DM',
              valueGetter: (params) => {
                return params.data.last4thQuarterDMStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            }
          ]
        },
        {
          colId: 'POC Contact',
          marryChildren: true,
          headerName: 'POC Contact',
          children: [
            {
              headerName: 'Full Name',
              valueGetter: (params) => {
                return params.data.pocFirstName + ' ' + params.data.pocLastName;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            },
            {
              headerName: 'Email',
              valueGetter: (params) => {
                return (params.data.email.length > 0) ? params.data.email.toLowerCase() : 'Not Available';
              },
              filter: 'agTextColumnFilter',
              sortable: true
            }
          ]
        }
      ];

    }

  }


  checkQuarterYear() {

    this.curMonth = (new Date().getMonth() + 1);
    this.curYear = new Date().getFullYear();
    if (this.curMonth == 1 || this.curMonth == 2 || this.curMonth == 3) {
      this.curQtr = 1;
    }
    else if (this.curMonth == 4 || this.curMonth == 5 || this.curMonth == 6) {
      this.curQtr = 2;
    }
    else if (this.curMonth == 7 || this.curMonth == 8 || this.curMonth == 9) {
      this.curQtr = 3;
    }
    else if (this.curMonth == 10 || this.curMonth == 11 || this.curMonth == 12) {
      this.curQtr = 4;
    }

    if (this.iffDelinqReport.value.reportingYrSelect < this.curYear) {
      return true;
    } // && this.curQtr >= this.iffDelinqReport.value.reportingQtrSelect) {
    if (this.iffDelinqReport.value.reportingYrSelect > this.curYear) {
      this.alertService.error('Emails cannot be sent for any future reporting qtrs');
      return false;
    }
    if (this.iffDelinqReport.value.reportingYrSelect == this.curYear && this.curQtr <= this.iffDelinqReport.value.reportingQtrSelect) {
      this.alertService.error('Emails cannot be sent for any future reporting qtrs');
      return false;
    }
    return true;
  }




}
